import React, { FC } from 'react'

interface IToolGetPlaysProps {}
const ToolGetPlays: FC<IToolGetPlaysProps> = () => {
  return <div className="p-3">Tool Get Plays</div>
}

export default ToolGetPlays
